import { render, staticRenderFns } from "./EditarCliente.vue?vue&type=template&id=811dd818&"
import script from "./EditarCliente.vue?vue&type=script&lang=js&"
export * from "./EditarCliente.vue?vue&type=script&lang=js&"
import style0 from "./EditarCliente.vue?vue&type=style&index=0&id=811dd818&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports